module.exports = __webpack_public_path__ + "img/puesta-en-valor-1-zoom.5eb6f2ad.jpg";